<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />

  <div class="page">

    <div class="mb-4" style="width:300px; display:block; margin:auto">
      <small>Righe da creare</small>
      <Slider v-model="maxItems" :step="2" :min="2" :max="204" /> 
      <span>{{maxItems}}</span>
    </div>

    <DataTable :value="items" v-model:selection="selectedItems" :filters="filters" responsiveLayout="scroll">

        <Column selectionMode="multiple" style="width: 3rem" :exportable="false"></Column>
        <Column field="code" header="Pdr" :sortable="true"></Column>

    </DataTable>

  </div>
  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        />
    </div>
  </div>
</template>

<script>

import { ref, getCurrentInstance} from 'vue';
import Service from '@/services/ask-operation/operation-service'
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader
  },
    
  setup(props) {
    const page = { name: 'pdrs-multipdrs'}
    const loader = ref(false)
    const toast = useToast();

    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const filters = ref({
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
    });
    const items = ref(props.data)
    const selectedItems = ref(items.value);
    const maxItems = ref(102)
      
    
      
    const onOkButton = () => {
      toast.removeGroup(page.name);

      if (Object.entries(selectedItems.value).length !== 0 && Object.entries(selectedItems.value).length <= maxItems.value) {
        loader.value = true
        service.downloadMultipdrsPdf(selectedItems.value, maxItems.value)
        .finally(()=>{
          loader.value = false
          _reset()
          self.$eventBus.emit(`dialog-return-ok-button`, {}) 
        })
      } else {
        if (selectedItems.value.length == 0) {
          toast.add({severity:'warn', summary: 'Attenzione', detail:'Non hai selezionato nessun elemento', group: page.name});
        }
        if (selectedItems.value.length > maxItems.value) {
          toast.add({severity:'warn', summary: 'Attenzione', detail:`Il massimo di elementi selezionabili è ${maxItems.value}`, group: page.name});
        }

      }
    }


    const onCancelButton = () => {
      _reset()
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }

    const _reset = () =>{
      selectedItems.value = []
    }


    return {
      page,
      filters,
      items,
      selectedItems,
      loader,
      maxItems,
      onOkButton,
      onCancelButton
    }
  }
}


</script>


